import { RouteObject } from 'react-router-dom'

import AuthLayout from '@/presentation/components/ui/layout/auth-layout'
import BasicLayout from '@/presentation/components/ui/layout/basic-layout'

import { PathConstants } from '../../paths'
import { RedirectIfAuthenticated } from './guards'
import * as Pages from './pages'

// ============================================
// MÓDULO AUTH — ÁRVORE PÚBLICA (não exige conta logada)
// "auth" aqui = árvore não-autenticada (montada fora do gate de conta), não
// apenas "telas de login". Tem dois tipos de rota:
//   1) Fluxo de entrada (login, recuperação de senha, primeiro acesso, ...):
//      envolvidas por RedirectIfAuthenticated — usuário logado é redirecionado
//      pro app (não faz sentido logar de novo).
//   2) Públicas abertas (skill-explorer-catalog, cbu/success): SEM
//      RedirectIfAuthenticated — acessíveis por qualquer um, logado ou não.
// ============================================

export const PublicRoutes = (): RouteObject[] => {
  return [
    {
      element: (
        <RedirectIfAuthenticated>
          <AuthLayout />
        </RedirectIfAuthenticated>
      ),
      children: [
        {
          path: PathConstants.Routes.LOGIN.value,
          element: <Pages.LoginPage />
        },
        {
          path: PathConstants.Routes.FORGOT_PASSWORD.value,
          element: <Pages.ForgotPasswordPage />
        },
        {
          path: PathConstants.Routes.RESET_PASSWORD.value,
          element: <Pages.ResetPasswordPage />
        },
        {
          path: PathConstants.Routes.RESEND_ACCESS.value,
          element: <Pages.ResendAccessPage />
        },
        {
          path: PathConstants.Routes.LOGIN_FIRST_ACCESS.value,
          element: <Pages.LoginFirstAccessPage />
        }
      ]
    },
    {
      element: (
        <RedirectIfAuthenticated>
          <BasicLayout footerVariant="compact" />
        </RedirectIfAuthenticated>
      ),
      children: [
        {
          path: PathConstants.Routes.FIRST_ACCESS.value,
          element: <Pages.FirstAccessPage />
        },
        {
          path: PathConstants.Routes.FIRST_ACCESS_CPF.value,
          element: <Pages.FirstAccessCpfPage />
        }
      ]
    },
    // Públicas abertas: SEM RedirectIfAuthenticated — acessíveis por qualquer
    // um (logado ou anônimo). Por isso ficam fora dos blocos guardados acima.
    {
      path: PathConstants.Routes.CB_UNICO_SUCCESS.value,
      element: <Pages.CbUnicoSuccessPage />
    },
    {
      path: PathConstants.Routes.SKILL_EXPLORER_CATALOG.value,
      element: <Pages.SkillExplorerCatalogPage />
    },
    {
      path: PathConstants.Routes.APP_REDIRECT.value,
      element: <Pages.AppRedirectPage />
    }
  ]
}

// ============================================
// ROTA DE LOGOUT
// Fica na árvore AUTENTICADA (é preciso ter sessão para deslogar), portanto NÃO
// deve ser envolvida por RedirectIfAuthenticated. Renderiza apenas um spinner.
// ============================================

export const makeLogoutRoute = (): RouteObject => ({
  path: PathConstants.Routes.LOGOUT.value,
  element: <Pages.LogoutPage />
})
